export const LOCAL_STORAGE_CONSTANT = {
  CURRENT_LANGUAGE_STATE_KEY: 'currentLang',
  LOGIN_TOKEN: 'lt',
  USER_DATA: 'ud',
  USER_LIST: 'ul',
  RECENT_REPORTS: 'rr',
  BIOGAS_STATUS: 'bs',
  PROMPT_BEEN_SHOWN: 'pbs',
  REPORT_PERIOD: 'rp',
  LATEST_WORK: 'lw',
  SELECTED_USERS: 'su',
  SELECTED_CUSTOMERS: 'sc',
  SELECTED_CUSTOMER_GROUPS: 'scg',
  SELECTED_VEHICLES: 'sv',
  SELECTED_SENDERS: 'ss',
  SELECTED_RECEIVERS: 'sr',
  SELECTED_PRODUCTS: 'sp',
  SELECTED_STATUS: 'ssu',
  SELECTED_WORK_TYPES: 'swt',
  SELECTED_WORK_OBJECTS: 'swo',
  SELECTED_WORK_GROUPS: 'swg',
  SELECTED_PRODUCT_GROUPS: 'spg',
  SELECTED_BIOGAS_PRODUCTS: 'sbp',

  BIOGAS_SUBSTRATE_DETAILS: 'bsd',
  BIOGAS_BIOFERTILIZER_DETAILS: 'bbd',
  SELECTED_ANALYSIS_KEY: 'ak',
};
